import { PickupPointDto, PickupPointModel } from '../types/pickup-point'

import { transformShippingPointDto } from './shipping-point'

export const transformPickupPointDto = ({
  distance,
  preferred,
  point,
  distance_unit,
  distance_label,
}: PickupPointDto): PickupPointModel => ({
  distance,
  preferred,
  distanceUnit: distance_unit,
  distanceLabel: distance_label,
  point: transformShippingPointDto(point),
})

export const transformPickupPointsDto = (
  pickupPointDto: Array<PickupPointDto>,
): Array<PickupPointModel> => pickupPointDto.map(transformPickupPointDto)
